<script setup lang="ts">
const props = defineProps({
  activeSegments: {
    type: Number,
    required: true,
  },

  /*
    size: small, input
    */
  size: {
    type: String,
    required: true,
  },

  colorName: {
    type: String,
    required: true,
  },

  explanationText: {
    type: String,
    default: undefined,
  },
});

const isInactive = computed(() => {
  const activeSegments = props.activeSegments;

  return (n: number) =>
    Array.from({ length: 2 + n })
      .map((_, index) => index)
      .includes(activeSegments);
});
</script>

<template>
  <div style="display: flex; flex-direction: column; height: 100%; width: 100%">
    <Copy v-if="size == 'small'" type="label" size="small" :color="`--color-${colorName}-300`"> {{ explanationText }} </Copy>

    <CompositionSpacer v-if="size == 'small'" direction="vertical" size="tiny" />

    <div
      :class="[$style.container, $style[`height-${size}`]]"
      :style="{
        '--segmented-bar-background-color': `var(--color-${colorName}-200)`,
        '--segmented-bar-border-color': `var(--color-${colorName}-100)`,
      }"
    >
      <div v-for="n in 6" :key="n" :class="[$style.segment, isInactive(n - 2) && $style.inactive]" />
    </div>
  </div>
</template>

<style module>
.container {
  display: flex;
  width: 100%;
  height: 100%;
  background-color: var(--segmented-bar-border-color);
  border-radius: var(--border-radius-medium);
}

.container.height-small {
  height: 0.5rem;
  clip-path: inset(0 0 0 0 round var(--border-radius-medium));
}

.container.height-input {
  height: 2.5rem;
  clip-path: inset(0 0 0 0 round var(--border-radius-medium));
}

.segment {
  display: flex;
  width: 16.666666%;
  height: 100%;
}

.segment:first-child {
  border-top-left-radius: var(--border-radius-medium);
  border-bottom-left-radius: var(--border-radius-medium);
}

.segment:last-child {
  border-top-right-radius: var(--border-radius-medium);
  border-bottom-right-radius: var(--border-radius-medium);
}

.segment:not(:last-child) {
  border-right: dotted 1px var(--color-white);
}

.segment:not(.inactive) {
  background-color: var(--segmented-bar-background-color);
}
</style>
